import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatosProyectoComponent } from '../../../comun/components/datos-proyecto/datos-proyecto.component';
import { DatosPersonalesComponent } from '../../../comun/components/datos-personales/datos-personales.component';
import { DatosDomicilioComponent } from '../../../comun/components/datos-domicilio/datos-domicilio.component';
import { CaCardComponent } from '@global-front-components/ui/card';
import { CaButtonComponent } from '@global-front-components/ui/button';
import { CaIcon } from '@global-front-components/ui/form-field';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { IdiomasComponent } from '../../../comun/components/idiomas/idiomas.component';
import { CaRadioButtonComponent, CaRadioGroupDirective } from '@global-front-components/ui/radio-button';
import { EnvioEmailComponent } from '../../../comun/components/envio-email/envio-email.component';
import { DatosRecomendadorPropuesta, MultiGuardado, PolizaSalud, RiesgoSalud } from '../../../comun/model/salud.model';
import { DatosDomicilioConfig, DatosPersonalesConfig, ModoEdicion } from '../../../ui/model/catalogo-config.model';
import { IdiomaCatalogo } from '../../../comun/model/catalogo.model';
import { FlujoPolizaNavigationComponent } from '../../../comun/components/base/flujo-poliza-navigation.component';
import { Router } from '@angular/router';
import { PolizaStoreService } from '../../../comun/services/store/poliza-store.service';
import { CatalogoSvgStoreService } from '../../../comun/services/store/catalogo-svg-store.service';
import { PolizaSaludApiService } from '../../services/api/poliza-salud-api.service';
import { GlobalMessageHandlerService } from '../../../comun/services/util/global-message-handler.service';
import { Domicilio, Persona } from '../../../comun/model/poliza.model';
import { AgrupacionPolizasSalud } from '../../../comun/model/recomendador.model';
import { PolizaSaludStoreService } from '../../services/store/poliza-salud-store.service';
import { ImpresionColectivasComponent } from '../impresion-colectivas/impresion-colectivas.component';

@Component({
	selector: 'app-guardar-multi-proyecto',
	standalone: true,
	imports: [
		CommonModule,
		DatosProyectoComponent,
		DatosPersonalesComponent,
		DatosDomicilioComponent,
		CaCardComponent,
		CaButtonComponent,
		CaIcon,
		ReactiveFormsModule,
		TranslateModule,
		IdiomasComponent,
		CaRadioButtonComponent,
		CaRadioGroupDirective,
		EnvioEmailComponent,
		ImpresionColectivasComponent
	],
	templateUrl: './guardar-multi-proyecto.component.html',
	styleUrls: ['./guardar-multi-proyecto.component.scss']
})
export class GuardarMultiProyectoComponent extends FlujoPolizaNavigationComponent<PolizaSaludStoreService> implements OnInit {
	guardarForm!: FormGroup;
	propuesta!: PolizaSalud;
	propuestaGuardada!: PolizaSalud;
	agrupacionesPropuestas: AgrupacionPolizasSalud[] = [];
	tomadorConfig: DatosPersonalesConfig;
	domicilioTomadorConfig: DatosDomicilioConfig;
	idiomas: IdiomaCatalogo[] = [];
	mostrarEnvioEmail = false;
	esDental = false;
	datosRecomendadorPropuesta: DatosRecomendadorPropuesta | null = null;

	constructor(
		router: Router,
		polizaStore: PolizaSaludStoreService,
		catalogoSvgStore: CatalogoSvgStoreService,
		private fb: FormBuilder,
		private polizaApiService: PolizaSaludApiService,
		private translateService: TranslateService,
		private globalMessageHandler: GlobalMessageHandlerService
	) {
		super(router, polizaStore, catalogoSvgStore);
		this.esDental = this.getNavigationParam('esDental');
	}

	ngOnInit(): void {
		this.catalogoSvgStore.catalogoProtocoloSubject$.subscribe((catalogo) => {
			if (catalogo) {
				this.idiomas = catalogo.idiomas;
			}
		});

		this.guardarForm = this.fb.group({
			datosProyecto: this.fb.group({}),
			datosPersonalesTomador: this.fb.group({}),
			datosDomicilioTomador: this.fb.group({}),
			datosIdiomas: this.fb.group({})
		});
		this.polizaStore.polizaSubject$.subscribe((propuesta: PolizaSalud) => {
			if (propuesta) {
				this.propuesta = propuesta;
				this.tomadorConfig = {
					persona: this.propuesta?.tomador || {},
					rol: 'tomador',
					modoEdicion: ModoEdicion.VALORES,
					mostrarDocumento: true,
					mostrarNombre: true,
					mostrarFechaNacimiento: false,
					mostrarSexo: false
				}
				this.domicilioTomadorConfig = {
					domicilio: this.propuesta?.tomador?.domicilio || {},
					rol: 'tomador',
					modoEdicion: ModoEdicion.VALORES,
					mostrarVia: true,
					mostrarLocalidad: true,
					mostrarProvincia: true
				};
			}
		});
		this.polizaStore.agrupacionesPoliza$.subscribe((agrupaciones: AgrupacionPolizasSalud[]) => {
			if (agrupaciones) {
				this.agrupacionesPropuestas = agrupaciones;
			}
		});
		this.polizaStore.datosRecomendador$.subscribe((datos: DatosRecomendadorPropuesta | null) => {
			this.datosRecomendadorPropuesta = datos;
		});
	}

	guardarProyecto(imprimir?: boolean): void {
		let propuestaGuardar = this.propuesta;
		this.completarProyecto(propuestaGuardar);
		let multiGuardarPropuesta : MultiGuardado = {
			propuesta: propuestaGuardar,
			colectivas: this.agrupacionesPropuestas.map(a => a.polizasColectivas?.map(p => p.colectiva?.numColectiva)).flat(),
			datosRecomendador: this.datosRecomendadorPropuesta
		};
		this.polizaApiService.multiGuardarPropuesta(multiGuardarPropuesta).subscribe({
			next: (propuestaGuardada: PolizaSalud) => {
				if (propuestaGuardada?.codigoPropuesta){
					this.propuestaGuardada = propuestaGuardada;
					this.globalMessageHandler.emitSuccess(this.translateService.instant('GUARDAR_PROYECTO.PROPUESTA_GUARDADA', 
						{ codigoPropuesta: this.propuestaGuardada.codigoPropuesta }));
					if (imprimir){
						// this.polizaApiService.imprimirPoliza(propuestaGuardada.codigoPropuesta, Number(propuestaGuardar.codigoProducto), propuestaGuardar.codigoIdioma, true)
						// .subscribe((url: string) => {
						// 	if (url) {
						// 		window.open(url, '_blank');
						// 	}
						// });
					}
				}
			}
		});
	}

	completarProyecto(propuesta: PolizaSalud): void {
		const nombreProyecto = this.guardarForm.get('datosProyecto.nombreProyecto')?.value;
		const codIdioma = this.guardarForm.get('datosIdiomas.codIdioma')?.value;
		//this.propuesta.nombreProyecto = nombreProyecto;
		propuesta.codigoIdioma = codIdioma;
		propuesta.nombreProyecto = nombreProyecto;
	}

	public onTomadorChange(persona: Persona): void {
		this.propuesta.tomador = persona;
	}

	public onDomicilioTomadorChange(domicilio: Domicilio): void {
		this.propuesta.tomador.domicilio = domicilio;
	}

	cambioEnvioEmail(evento: any) {
		if (evento?.value === "1") {
			this.mostrarEnvioEmail = true;
			this.guardarForm.addControl('envioEmail',this.fb.group({}));
		} else {
			this.mostrarEnvioEmail = false;
			this.guardarForm.removeControl('envioEmail');
		}
	}
}
